/* eslint-disable import/no-default-export */
import React from 'react';
import styled from 'styled-components';

import Button from '../Button';

const ButtonLabel = styled.span`
  line-height: 12px;
  margin-left: 4px;
`;

const Icon = styled.span`
  display: inline-block;

  svg {
    height: ${({ height }) => height}px;
    width: ${({ width }) => width}px;
  }
`;

const IconButton = ({
  children,
  icon,

  iconHeight = 12,
  iconWidth = 12,

  ...buttonProps
}) => (
  <Button {...buttonProps}>
    <Icon height={iconHeight} width={iconWidth}>
      {icon}
    </Icon>
    <ButtonLabel>{children}</ButtonLabel>
  </Button>
);

export default IconButton;



// WEBPACK FOOTER //
// ./app/common/components/canonical-components/canonical-card/buttons/IconButton.js